var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.display)?_c('v-alert',{attrs:{"dense":"","type":_vm.type}},[_c('div',[_vm._v(_vm._s(_vm.message))]),((_vm.errors && Object.keys(_vm.errors).length))?_c('div',_vm._l((_vm.errors),function(error,key){return _c('div',{key:`alert-error-${key}`},[_vm._v(_vm._s(error[0]))])}),0):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }